import { render } from "./PresupuestoShow.vue?vue&type=template&id=ce5193fa"
import script from "./PresupuestoShow.vue?vue&type=script&lang=js"
export * from "./PresupuestoShow.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__